/* eslint-ignore */
// @ts-nocheck
import React, { useCallback } from 'react';

import { BsCheck } from 'react-icons/bs';

import { Container, Content, Input, Span } from './styles';

function CustomCheckBox({ text, isChecked, setIsChecked, includeMarginTop = 0 }) {

  const handleCheckChange = useCallback((e) => {
    setIsChecked(e.target.checked);
  },[isChecked]);

  return (
    <Container includeMarginTop={includeMarginTop}>
      <Content isChecked={isChecked}>
        {text || ''}
        <Input
          type="checkbox"
          onChange={handleCheckChange}
          checked={isChecked}
        />
        <Span isChecked={isChecked} />
        {isChecked && <BsCheck size={14} />}
      </Content>
    </Container>
  );
}

export default CustomCheckBox;
